module.exports = __webpack_public_path__ + "img/logo_px40_clara_quadrada.2c70d221.png";